import {
    AuthAPIInstance
} from "@/api";

class AuthHelperClass {


    constructor() {
        this.token = '';

        this.refreshTimeout = null;
    }



    async getToken() {
        const token = localStorage.getItem('token')

        return token;
    }

    async setToken(token) {
        this.token = token;

        localStorage.setItem('token', token)
    }

    async getUser() {
        const response = localStorage.getItem('user')

        let user;

        try {
            user = JSON.parse(response)
        } catch (error) {
            console.log('User Parse Error: ', error);
        }

        return user;
    }

    async setUser(user) {

        this.user = user;

        localStorage.setItem('user', JSON.stringify(user))
    }



    /**
     * 
     * @param {number} exp 
     */
    async setRefresh(exp) {
        const now = new Date().getTime();
        const expiresAt = Number(exp); // Convert to milliseconds

        const refreshTime = expiresAt - now - 1000 * 60 * 5; // 5 minutes before expiration
        // const refreshTime = expiresAt - now - 1000 * 10; // 10 seconds before expiration

        if (this.refreshTimeout) {
            clearTimeout(this.refreshTimeout);
        }


        this.refreshTimeout = setTimeout(async () => {
            if (this.refreshTimeout)
                clearTimeout(this.refreshTimeout);

            try {
                const resp = await AuthAPIInstance.refreshToken(await this.getToken());

                if (!(resp.token && resp.exp)) {
                    throw new Error('Token or Exp is undefined');
                }

                await this.setToken(resp.token);
                await this.setRefresh(resp.exp);


            } catch (error) {
                await this.setToken();
                await this.setUser();

                // return window.location.href = '/sign-in'
            }



        }, refreshTime);
    }

}

export const AuthHelper = new AuthHelperClass()